import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { findPathToActiveItem } from '~/portal/components/ConsumerSideNavigation/helpers'
import { NestedSideNavItem } from '~/portal/components/ConsumerSideNavigation/NestedSideNavItem'
import { PublishedTableOfContents } from '~/portal/types/content'

export const ConsumerSideNavigation = ({
  tableOfContents,
  onClick,
  flat,
  apiTitle,
}: {
  tableOfContents: PublishedTableOfContents[],
  accentColor?: string,
  onClick?: (e: any) => void,
  flat?: boolean,
  apiTitle?: string,
}) => {

  const { t } = useTranslation()
  const location = useLocation()

  const defaultOpenIds = useMemo(() => findPathToActiveItem(tableOfContents, location.pathname), [location.pathname])

  return (
    <div className="sp-sidenav flex flex-col h-full">
      <div aria-label={t('consumer.sideNavigation.ariaLabel')} data-testid="consumer-side-navigation" className="sp-sidenav-inner flex-grow overflow-auto bg-(--sp-sidenav-item-bg,var(--sp-color-surface))">
        {tableOfContents.map(tocItem => (
          <NestedSideNavItem key={tocItem.path} tocItem={tocItem} level={0} openIds={defaultOpenIds} onClick={onClick} flat={flat} apiTitle={apiTitle} />
        ))}
      </div>
    </div>
  )
}